import React, { useState } from 'react'
import BackGroundLayout from '../../BackGroundLayout/BackGroundLayout';
import styles from './Contact.module.scss';
import emailjs from '@emailjs/browser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { CircularProgress, Snackbar, Alert } from '@mui/material';
import { BASIC_CONTENT } from '../../../App.constant';

function Contact() {

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    to_name: 'Raj'
  });
  const [loading, setLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState({status: '', open: false});
  const { name = '', email = '', message = '' } = formData;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const toasterMsg = {
    success: 'Message sent successfully',
    error: 'Error in sending message',
    info: 'Please fill all the fields',

  };

  const sendEmail = (e) => {
    if (name !== '' || email !== '', message !== '') {
      e.preventDefault(); // Prevent page reload
      setLoading(true);

      const serviceID = 'service_vc5ywvh';
      const templateID = 'template_qeeg2ow';
      const userID = '4aOZxg1fvdSURbl2T';

      emailjs.send(serviceID, templateID, formData, userID)
        .then((response) => {
          setLoading(false);
          console.log('Email sent successfully!', response.status, response.text);
          setFormData({ name: '', email: '', message: '' });
          setOpenSnackbar({...openSnackbar, status: 'success', open: true});
        }, (error) => {
          setLoading(false);
          setOpenSnackbar({ ...openSnackbar, status: 'error', open: true });
          console.error('Failed to send email. Error:', error);
        });
    } else {
      setOpenSnackbar({ ...openSnackbar, status: 'info', open: true });
    }
  }
  const handleExternalNavigation = (url) => {
    window.open(url, '_blank'); // Open the URL in a new tab
  };
  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar({ ...openSnackbar, open: false }); // Close the Snackbar
  };

  return (
    <div id='contact' className={styles.container}>
      <BackGroundLayout backGroundText="Contact" overlapText="Get in Touch" />
      <div className={styles.contentWrapper}>
        <div className={styles.leftPanel}>
          <section className={styles.personalAddress}>
            <h2 className={styles.labelAddress}>Address</h2>
            <p className={styles.addressContent}>
              56,Kadai Amman Kovil
              street,veeravanallur 627426,
              Tirunelveli,
              TamilNadu,
              India.
            </p>
          </section>
          <section className={styles.contactInfo}>
            <div className={styles.iconWithInfo}>
              <FontAwesomeIcon className={styles.faIcon} icon={faPhone} />
              <span>(+91) {BASIC_CONTENT.number}</span>
            </div>
            <div className={styles.iconWithInfo}>
              <FontAwesomeIcon className={styles.faIcon} icon={faEnvelope} />
              <span>{BASIC_CONTENT.email}</span>
            </div>
          </section>
          <section className={styles.followSection}>
            <h2 className={styles.labelFolowMe}>Follow Me</h2>
            <div className={styles.followIcons}>
              <FontAwesomeIcon icon={faLinkedin} style={{ color: '#0077B5', fontSize: '25px', marginRight: '10px' }} onClick={() => handleExternalNavigation('https://www.linkedin.com/in/raj-narayanan-63a110134/')}/>
              <FontAwesomeIcon icon={faGithub} style={{ color: '#333', fontSize: '25px', marginRight: '10px' }} onClick={() => handleExternalNavigation('https://github.com/rajamax333')} />
            </div>

          </section>
        </div>
        <div className={styles.rightPanelWrapper}>
          <div className={styles.rightPanel}>
            <h2>Send Us a Note</h2>
            <div className={styles.nameEmailBox}>
              <TextField
                label="Name"
                name='name'
                variant="outlined"
                fullWidth
                value={formData?.name}
                onChange={handleChange}
              />
              <TextField
                label="Email"
                name='email'
                variant="outlined"
                fullWidth
                value={formData?.email}
                onChange={handleChange}
              />
            </div>
            <TextField
              label="Tell us more about your needs"
              multiline
              name='message'
              rows={4}
              value={formData?.message}
              variant="outlined"
              fullWidth
              onChange={handleChange}
            />
          </div>
          <Button
            variant="contained"
            color="primary"
            disabled={loading}  // Disable the button when loading
            startIcon={loading && <CircularProgress size={20} />}
            className={styles.sendMessagebtn}
            onClick={sendEmail}>
            Send Message
          </Button>
          <Snackbar open={openSnackbar?.open} autoHideDuration={3000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
            <Alert onClose={handleCloseSnackbar} severity={openSnackbar?.status} sx={{ width: '100%' }}>
              {toasterMsg[openSnackbar?.status]}
            </Alert>
          </Snackbar>
        </div>
      </div>
    </div>
  )
}

export default Contact